import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';
import { NavigationStudentNormalSmall } from '@strava/icons';
import styles from './SubscriptionStatus.styles.scss';
import { I18nPrefix } from '../../shared/SubscriberSummary';

const SubscriptionStatus = ({ subscriptionInfo, studentInfo }) => {
  const { isStudent, endDate } = studentInfo;
  const {
    startDate,
    nextBillingDate,
    renewalPrice,
    currency,
    discountPercentage,
    organicPrice
  } = subscriptionInfo;

  const formattedRenewalPrice = Cldr.formatCurrency(renewalPrice, currency);
  const formattedOrganicPrice = Cldr.formatCurrency(organicPrice, currency);

  return (
    <>
      <p>
        {I18n.t_html(`${I18nPrefix}.member_since`, {
          date: startDate
        })}
      </p>
      <p className="color-n80-asphalt">
        {I18n.t(`${I18nPrefix}.annual_renew`, {
          date: nextBillingDate,
          price: formattedRenewalPrice
        })}
      </p>
      {isStudent && (
        <div className={`${styles.studentDiscount} color-n80-asphalt`}>
          <div className={styles.icon}>
            <NavigationStudentNormalSmall />
          </div>
          <p>
            {I18n.t(`${I18nPrefix}.students.reverification`, {
              percentage: I18n.percentFormatter().format(-discountPercentage),
              date: endDate,
              price: formattedOrganicPrice
            })}
          </p>
        </div>
      )}
    </>
  );
};

SubscriptionStatus.defaultProps = {
  studentInfo: {
    isStudent: false,
    endDate: null
  }
};

SubscriptionStatus.propTypes = {
  subscriptionInfo: PropTypes.shape({
    startDate: PropTypes.string,
    nextBillingDate: PropTypes.string,
    renewalPrice: PropTypes.number,
    currency: PropTypes.string,
    organicPrice: PropTypes.number,
    discountPercentage: PropTypes.number
  }).isRequired,
  studentInfo: PropTypes.shape({
    isStudent: PropTypes.bool,
    endDate: PropTypes.string
  })
};

export default SubscriptionStatus;
